import React from 'react'
import Hero from '../components/Hero'
import Features from '../components/Features'
import Teams from '../components/Teams'
import FAQ from '../components/FAQ'
import ContactUs from '../components/ContactUs'

const Home = () => {
  return (
    <>
        <Hero/>
        <Features/>
        <Teams/>
        <FAQ/>
        <ContactUs/>
    </>
  )
}

export default Home